import React from 'react';
import { Link } from 'react-router-dom';
import { Send, ShieldCheck, Terminal } from 'lucide-react';
import { CONFIG } from '../mock/mock';

export default function Footer() {
  return (
    <footer className="border-t border-cyan-500/10 mt-24">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10 grid gap-8 sm:grid-cols-2 lg:grid-cols-4">
        <div>
          <div className="flex items-center gap-3">
            <div className="h-9 w-9 rounded-lg glass flex items-center justify-center glow-cyan">
              <Terminal className="h-5 w-5 text-cyan-300" />
            </div>
            <div>
              <div className="font-display text-sm tracking-[0.25em] font-semibold text-white">{CONFIG.siteName}</div>
              <div className="text-[10px] tracking-[0.3em] text-cyan-300/70">{CONFIG.tagline}</div>
            </div>
          </div>
          <p className="mt-4 text-sm text-slate-400 max-w-xs">Institutional-grade AI signals synchronized with live market timing. Verified members only.</p>
        </div>

        <div>
          <h4 className="text-xs tracking-[0.25em] text-cyan-300/80 mb-3">TERMINAL</h4>
          <ul className="space-y-2 text-sm text-slate-300">
            <li><Link to="/verify" className="hover:text-cyan-300">Verify Trader ID</Link></li>
            <li><Link to="/login" className="hover:text-cyan-300">Member Login</Link></li>
            <li><a href={CONFIG.referralLink} target="_blank" rel="noreferrer" className="hover:text-cyan-300">Create {CONFIG.brokerName} Account</a></li>
          </ul>
        </div>

        <div>
          <h4 className="text-xs tracking-[0.25em] text-cyan-300/80 mb-3">COMMUNITY</h4>
          <a href={CONFIG.telegramLink} target="_blank" rel="noreferrer" className="btn-ghost inline-flex items-center gap-2 px-4 py-2 rounded-md text-sm">
            <Send className="h-4 w-4 text-cyan-300" /> Join Telegram
          </a>
        </div>

        <div>
          <h4 className="text-xs tracking-[0.25em] text-cyan-300/80 mb-3">STATUS</h4>
          <div className="flex items-center gap-2 text-sm text-slate-300"><ShieldCheck className="h-4 w-4 text-emerald-400" /> Secure Verification</div>
          <div className="mt-2 flex items-center gap-2 text-sm text-slate-300"><span className="live-dot" /> AI Engine Online</div>
        </div>
      </div>

      <div className="border-t border-cyan-500/10">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-slate-500">
          <p>© {new Date().getFullYear()} The Alpha Trader AI. All rights reserved.</p>
          <p>Risk warning: Trading derivatives involves substantial risk. This site is an educational tool.</p>
        </div>
      </div>
    </footer>
  );
}
